<template>
  <div class="card-step">
    <div class="form-title mt-4 mb-7 mx-auto">
      {{ $t('subscription.cardDescription') }}
    </div>
    <v-sheet elevation="2" rounded class="form ma-auto pt-5 pb-7 px-6">
      <cardForm @submit="$emit('submit', $event)"/>
      <div class="text-center mt-5">
        <div v-if="selectedPlan" class="mt-3">{{ $t('subscription.infoP1') }} {{ subsctiptionName }} {{ $t('subscription.infoP2') }}  {{ subsctiptionName }} {{ $t('subscription.infoP3') }} {{price}}.</div>
        <div>
          <b>
            <a href="https://moviemethod.com/terms/" target="_blank">{{ $t('signUp.tos') }}</a>
          </b>
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import cardForm from './cardForm';

export default {
  name: 'addCardStep',

  props: {
    priceId: {
      type: String,
    },
  },

  components: {
    cardForm,
  },

  computed: {
    locale () {
      return this.$route.params.locale;
    },

    plans () {
      return this.$store.state.user.plans;
    },

    selectedPlan () {
      return this.plans.find(plan => plan.id === this.priceId);
    },

    subsctiptionName () {
      switch (this.selectedPlan.productName) {
      case '1 month':
        return this.$t('subscription.monthly');
      case '6 months':
        return this.$t('subscription.6-month');
      case '12 months':
        return this.$t('subscription.annual');

      default:
        return '';
      }
    },

    price () {
      const price = this.selectedPlan.unit_amount / 100;

      return this.locale === 'es' ? `${price} USD` : `US$${price}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  max-width: 356px
}

.form-title {
  white-space: pre;
  max-width: 356px;
  font-weight: bold;
  font-size: 32px;
  line-height: 39px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
}
</style>
